import { rem } from '../../utils/styles';
import styled from 'styled-components';

export const StyledLoading = styled.div`
	width: ${rem(50)};
	position: absolute;
	left: calc(50% - ${rem(25)});
	top: 45%;
`;
